function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerLocaleKeys from '../../../../locales/keys';
import { i18n } from 'invision-core';
import { defaultToZero, yesOrNo } from '../../../../reducers/selectors/customer.account.status.dashboard.selectors';
import { getContentType as _getContentType, getFriendlyDisplayName } from '../content.activity.helpers';
var CustomerContentActivityDetailController = /*#__PURE__*/function () {
  function CustomerContentActivityDetailController() {
    var _this = this;
    _classCallCheck(this, CustomerContentActivityDetailController);
    this.localeKeys = CustomerLocaleKeys;
    this.terminateStreamPopup = {
      onRegisterApi: function onRegisterApi(event) {
        _this.terminateStreamPopupApi = event.api;
      }
    };
    this.removeDownloadPopup = {
      onRegisterApi: function onRegisterApi(event) {
        _this.removeDownloadPopupApi = event.api;
      }
    };
  }
  return _createClass(CustomerContentActivityDetailController, [{
    key: "$onChanges",
    value: function $onChanges(changObj) {
      if (changObj.contentActivity) {
        this.setupAdvertisementGrid();
        this.getContentType();
      }
    }
  }, {
    key: "closeRemoveDownloadPopup",
    value: function closeRemoveDownloadPopup() {
      this.removeDownloadPopupApi.close();
    }
  }, {
    key: "removeDownloadPopupResult",
    value: function removeDownloadPopupResult(isCancelDownload) {
      if (isCancelDownload) {
        this.cancelStream()(this.contentActivity);
      }
      this.closeRemoveDownloadPopup();
    }
  }, {
    key: "closeTerminateStreamPopup",
    value: function closeTerminateStreamPopup() {
      this.terminateStreamPopupApi.close();
    }
  }, {
    key: "terminateStreamPopupResult",
    value: function terminateStreamPopupResult(isCancelStream) {
      if (isCancelStream) {
        this.cancelStream()(this.contentActivity);
      }
      this.closeTerminateStreamPopup();
    }
  }, {
    key: "openDialog",
    value: function openDialog() {
      this.contentActivity.Download ? this.removeDownloadPopupApi.open() : this.terminateStreamPopupApi.open();
    }

    // eslint-disable-next-line getter-return
  }, {
    key: "displayTerminateText",
    get: function get() {
      if (this.isActiveContent) {
        var key = !this.contentActivity.Download ? this.localeKeys.CONTENT_ACTIVITY.CANCEL_STREAM.DISPLAY_TEXT : this.localeKeys.CONTENT_ACTIVITY.CANCEL_DOWNLOAD.DISPLAY_TEXT;
        return i18n.translate(key);
      }
    }
  }, {
    key: "getContentType",
    value: function getContentType() {
      this.contentIdentifier = _getContentType(this.contentActivity);
      this.friendlyName = getFriendlyDisplayName(this.contentActivity);
    }
  }, {
    key: "setupAdvertisementGrid",
    value: function setupAdvertisementGrid() {
      this.advertisementGrid = [{
        name: i18n.translate(this.localeKeys.ADVERTISEMENTS.ADS_INITIATED),
        value: defaultToZero(this.contentActivity.InitiatedAdsCount)
      }, {
        name: i18n.translate(this.localeKeys.ADVERTISEMENTS.ADS_COMPLETED),
        value: defaultToZero(this.contentActivity.CompletedAdsCount)
      }, {
        name: i18n.translate(this.localeKeys.ADVERTISEMENTS.QUIT_DURING_AD),
        value: yesOrNo(this.contentActivity.StreamClosedDuringAd)
      }];
    }
  }]);
}();
export default {
  bindings: {
    cancelStream: '&',
    contentActivity: '<',
    isActiveContent: '<',
    isLoadingDetails: '<'
  },
  template: require('./detail.html'),
  controller: CustomerContentActivityDetailController
};